import { restore } from 'effector'
import { Currency } from '../../../../views/widgets/walletCard/types'
import { getCurrencies } from '../../wallets/details/model'

export const $currencies = restore<Currency[]>(
  getCurrencies.doneData.map((a) => a.body.items),
  [],
)
